module.exports = __webpack_public_path__ + "assets/2f15798c66d81138dff9b7df79ef1d43.jpg";